<template>
  <div class="cabinetDoorWrap">
    <div class="setBtnWrap">
      <div class="btn_line_list">
        <span class="btn" @click="handleOnOpenAll">打开所有</span>
        <span class="btn" @click="handleOonClearAll">一键清柜</span>
      </div>
      <div class="singleCell">
        单个格口
        <div class="btn_line_list">
          <span class="btn" @click="handleOnOpenSingle">打开格口</span>
          <span class="btn" @click="handleOnClearSingle">清除使用</span>
          <span @click="handleOnUpdateStatus">修改状态</span>
        </div>
      </div>
      <div class="backBtn btn" @click="handleOnBack">返回</div>
    </div>
    <div class="cellWrap">
      <div
        :class="['cellItem', cabinetIndex == index ? 'active' : '']"
        v-for="(item, index) in cabinetList"
        :key="index"
        @click="handleOnItem(item.name_line, item.status, index, item.name_box)"
      >
        <div class="num">{{ item.name_box }}</div>
        <div
          :class="[
            item.status == 1
              ? 'status'
              : item.status == 2
              ? 'useStatus status'
              : 'disableStatus status',
          ]"
        >
          {{
            item.status == 1 ? "未使用" : item.status == 2 ? "使用中" : "禁用中"
          }}
        </div>
      </div>
    </div>
    <el-dialog title="修改状态" :visible.sync="dialogFormVisible">
      <el-form ref="ruleForm">
        <el-form-item label="柜子状态" label-width="120px">
          <el-radio-group v-model="status">
            <el-radio :label="'1'">未使用</el-radio>
            <el-radio :label="'2'">已使用</el-radio>
            <el-radio :label="'3'">维修或损坏</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="handleOnConfirmUpdate"
          >确 定</el-button
        >
      </div>
    </el-dialog>
    <!-- 音频播放器（不会显示，仅用于播放） -->
    <audio ref="audioPlayer" preload="auto" playsinline webkit-playsinline style="opacity: 0"></audio>
  </div>
</template>
<script>
// @ is an alias to /src
import axios from "axios";
import Speech from "speak-tts";
import { API_BASE } from "@/config/api";
import { notifyRequestError } from "@/utils/requestError";
import {
  playVoiceAudio,
  bindAudioUnlock,
  resolveVoiceMp3,
} from "@/utils/voicePlayer";
export default {
  name: "HomeView",
  components: {},
  data() {
    return {
      deviceKey: "",
      cabinetList: [],
      nameLine: "",
      cabinetIndex: null,
      dialogFormVisible: false,
      status: "1",
      speech: null,
      nameBox: "",
    };
  },
  created() {
    console.log(this.$route.params.deviceKey);
    this.deviceKey = this.$route.params.deviceKey;
  },
  mounted() {
    this.getallCabinetList();
    this.$nextTick(() => {
      bindAudioUnlock(this.$refs.audioPlayer);
    });
    // this.speechInit();
  },
  methods: {
    //返回
    handleOnBack() {
      history.go(-1);
    },
    speechInit() {
      this.speech = new Speech();
      this.speech
        .init({
          lang: "zh-CN", // 设置语言为中文
          volume: 1, // 设置音量为最大
          rate: 1, // 设置语速为正常
          pitch: 1, // 设置音调为正常
          // ... 其他配置选项
        })
        .then(() => {
          console.log("语音插件已初始化");
        })
        .catch((err) => {
          console.error("初始化语音插件失败:", err);
        });
    },
    //更改柜子状态
    handleOnUpdateStatus() {
      var that = this;
      if (!that.nameLine) {
        that.$message.warning("请先选择柜子！");
        return;
      }
      this.dialogFormVisible = true;
    },
    //确认更新柜子状态
    handleOnConfirmUpdate() {
      var that = this;
      axios
        .get(
          `${API_BASE}/index.php?c=api&m=doCabinetNumberStatus&deviceKey=` +
            that.deviceKey +
            "&nameLine=" +
            that.nameLine +
            "&status=" +
            that.status
        )
        .then(function (res) {
          console.log(res);
          that.dialogFormVisible = false;
          if (res.data.code == 200) {
            that.getallCabinetList();
          }
        })
        .catch(function (error) {
          notifyRequestError(error);
        });
    },
    //清除使用单个柜子
    handleOnClearSingle() {
      var that = this;
      if (!that.nameLine) {
        that.$message.warning("请先选择柜子！");
        return;
      }
      if (that.status == 1 || that.status == 3) {
        that.$message.warning("请选择已使用的柜子！");
        return;
      }
      that
        .$confirm("您确定要清除" + that.nameLine + "格口吗?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
        .then(() => {
          axios
            .get(
              `${API_BASE}/index.php?c=api&m=doCabinetNumberStatus&deviceKey=` +
                that.deviceKey +
                "&nameLine=" +
                that.nameLine +
                "&status=1"
            )
            .then(function (res) {
              console.log(res);
              if (res.data.code == 200) {
                that.getallCabinetList();
              }
            })
            .catch(function (error) {
              notifyRequestError(error);
            });
        })
        .catch(() => {});
    },
    mp3Path(val) {
      return resolveVoiceMp3(val);
    },
    //打开单个柜子
    handleOnOpenSingle() {
      var that = this;
      if (!that.nameLine) {
        that.$message.warning("请先选择柜子！");
        return;
      }
      that
        .$confirm("您确定要打开" + that.nameLine + "格口吗?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
        .then(() => {
          axios
            .get(
              `${API_BASE}/index.php?c=api&m=openCabinetNumber&deviceKey=` +
                that.deviceKey +
                "&nameLine=" +
                that.nameLine
            )
            .then(function (res) {
              console.log(res);
              if (res.data.code == 200) {
                let msg = that.nameLine + "柜口已打开";
                // 获取音频元素
                const openSrc = that.mp3Path(that.nameBox);
                if (openSrc) {
                  playVoiceAudio(that.$refs.audioPlayer, openSrc);
                }
                that.getallCabinetList();
              }
            })
            .catch(function (error) {
              notifyRequestError(error);
            });
        })
        .catch(() => {});
    },
    //点击柜子获取编号
    handleOnItem(val, status, index, nameBox) {
      this.nameLine = val;
      this.cabinetIndex = index;
      this.status = status;
      this.nameBox = nameBox;
    },
    // 获取所有柜子
    getallCabinetList() {
      var that = this;
      that.nameLine = "";
      that.cabinetIndex = null;
      axios
        .get(
          `${API_BASE}/index.php?c=api&m=getGzList&deviceKey=` +
            that.deviceKey
        )
        .then(function (res) {
          console.log(res);
          if (res.data.code == 200) {
            that.cabinetList = res.data.data.gzList;
          }
        })
        .catch(function (error) {
          notifyRequestError(error, { throttleKey: "getGzList" });
        });
    },
    //打开所有柜子
    handleOnOpenAll() {
      var that = this;
      that
        .$confirm("您确定要打开全部格口吗?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
        .then(() => {
          that.handleOnopenCabinet();
        })
        .catch(() => {});
    },
    handleOnopenCabinet() {
      var that = this;
      that.cabinetList.map((item, index) => {
        axios
          .get(
            `${API_BASE}/index.php?c=api&m=openCabinetNumber&deviceKey=` +
              that.deviceKey +
              "&nameLine=" +
              item.name_line
          )
          .then(function (res) {
            console.log(res);
            if (res.data.code == 200) {
              if (that.cabinetList.length == parseInt(index + 1)) {
                // 获取音频元素
                const allOpenSrc = that.mp3Path("allOpen");
                if (allOpenSrc) {
                  playVoiceAudio(that.$refs.audioPlayer, allOpenSrc);
                }
                // that.speech.speak({ text: "柜门已全部打开！" }).then(() => {
                //   console.log("播报成功");
                // });
              }
            }
          })
          .catch(function (error) {
            notifyRequestError(error, { throttleKey: "batchCabinetOpen" });
          });
      });
    },
    //清除所有柜口
    handleOonClearAll() {
      var that = this;
      that
        .$confirm("您确定要清空全部格口吗?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
        .then(() => {
          that.handleOnClearAllCabinet();
        })
        .catch(() => {});
    },
    handleOnClearAllCabinet() {
      var that = this;
      that.cabinetList.map((item, index) => {
        axios
          .get(
            `${API_BASE}/index.php?c=api&m=doCabinetNumberStatus&deviceKey=` +
              that.deviceKey +
              "&nameLine=" +
              item.name_line +
              "&status=1"
          )
          .then(function (res) {
            console.log(res);
            if (res.data.code == 200) {
              if (that.cabinetList.length == parseInt(index + 1)) {
                // 获取音频元素
                const allCloseSrc = that.mp3Path("allClose");
                if (allCloseSrc) {
                  playVoiceAudio(that.$refs.audioPlayer, allCloseSrc);
                }
                // that.speech.speak({ text: "柜门已全部清除！" }).then(() => {
                //   console.log("播报成功");
                // });
                that.getallCabinetList();
              }
            }
          })
          .catch(function (error) {
            notifyRequestError(error, { throttleKey: "batchCabinetClear" });
          });
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.cabinetDoorWrap {
  height: 100vh;
  background: url("../assets/index_bg.jpg") no-repeat;
  background-size: 100% 100%;
  color: #fff;
  padding: 0 40px;
  .setBtnWrap {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-top: 30px;
    .btn {
      background: #658ecc;
      font-weight: bold;
      color: #fff;
      text-align: center;
      width: 100px;
      height: 42px;
      line-height: 42px;
      border-radius: 12px;
      cursor: pointer;
    }
    .btn_line_list {
      border: 1px solid #fff;
      display: flex;
      align-items: center;
      font-size: 20px;
      padding: 10px;
      border-radius: 12px;
      overflow: hidden;
      span {
        color: #d6f8fd;
        font-weight: 500;
        margin-right: 10px;
        display: inline-block;
        cursor: pointer;
        &:last-child {
          margin-right: 0;
        }
      }
    }
    .singleCell {
      display: flex;
      align-items: center;
      color: #d6f8fd;
      font-weight: 500;
      font-size: 20px;
      .btn_line_list {
        margin-left: 8px;
      }
    }
  }
  .cellWrap {
    margin-top: 15px;
    max-height: calc(100vh - 160px);
    background: rgba(75, 132, 211, 0.8);
    border-radius: 8px;
    padding: 25px;
    display: flex;
    justify-content: flex-start;
    flex-wrap: wrap;
    .cellItem {
      width: 10%;
      background: rgba(109, 156, 226, 0.8);
      padding: 10px 0;
      text-align: center;
      border-radius: 8px;
      height: 70px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      font-weight: 500;
      margin: 0 1% 1% 0;
      .num {
        color: #333;
        font-size: 18px;
      }
      .status {
        color: #4fe86c;
        font-size: 16px;
        margin-top: 8px;
      }
      .disableStatus {
        color: red;
      }
      .useStatus {
        color: #e1f8c0;
      }
      &.active {
        background: rgba(164, 203, 242, 0.8);
      }
    }
  }
}
</style>